import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, Subject, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarService {

  selectedCategory: any = null;
  public selectedCategoryChange: Subject<any> = new Subject<any>();
  apiUrl = environment.API_URL;

  constructor(private http : HttpClient) { }

  getBrands(type?: any): Observable<any> {
    var url = this.apiUrl + "/carBrand";
    if(type)
      url += '?vehicleType=' + type;

    return this.http.get(url);
  }

  getModels(brand?: any): Observable<any> {
    var url = this.apiUrl + "/carModel";
    if(brand)
      url += '?carBrand=' + brand;

    return this.http.get(url);
  }

  getCurrent(): any {
    return '';
  }
}
